/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Meeting_Prep_Invite_BodyInputs */



/**
* | output |
* | --- |
* | "Wundo lines up what you can carry over from earlier conversations. You edit all of it yourself." |
*
* @param {Meeting_Prep_Invite_BodyInputs} inputs
* @param {{ locale?: "en" | "nl" | "fr" }} options
* @returns {LocalizedString}
*/
export const meeting_prep_invite_body = /** @type {((inputs?: Meeting_Prep_Invite_BodyInputs, options?: { locale?: "en" | "nl" | "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Meeting_Prep_Invite_BodyInputs, { locale?: "en" | "nl" | "fr" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "nl") return /** @type {LocalizedString} */ ("Wundo zet klaar wat je uit vorige gesprekken kan meenemen. Je past alles zelf aan.")
	if (locale === "fr") return /** @type {LocalizedString} */ ("Wundo rassemble ce que vous pouvez reprendre des conversations précédentes. Vous adaptez tout vous-même.")
	return /** @type {LocalizedString} */ ("Wundo lines up what you can carry over from earlier conversations. You edit all of it yourself.")
});